export default __webpack_public_path__ + "static/media/jumbo-shrimps.be05180a.png";